import React, {
  useEffect,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { InView } from "react-intersection-observer";
import { Redirect } from "react-router-dom";

import { Button, ProgressBar, ScrollIndicator } from "../components";
import { useStore } from "../store";
import { makeNarrative } from "../data/narrative";
import "./Explore.scss";
import { urls } from "../utils";

export default function Explore() {
  const actions = useStore(useCallback((state) => state.actions, []));
  const isMobile = useStore(useCallback((state) => state.app.isMobile, []));
  const debugPlatform = useStore(
    useCallback((state) => state.app.debugPlatform, [])
  );
  const [goToPlatform, setGoToPlatform] = useState(debugPlatform);

  // Keep track of whether the SKIP button was pressed.
  // const [tutorialSkipped, setTutorialSkipped] = useState(false);
  const tutorialSkipped = useRef(false);

  const onboardingIdx = useStore(
    useCallback((state) => state.app.explore.onboardingIdx, [])
  );

  // This refers to all events data
  const data = useStore(useCallback((state) => state.data.events, []));
  const narrativeData = useMemo(() => makeNarrative({ data }), [data]);

  // Used for programmatic scrolling
  // const rootEl = useStore(useCallback((state) => state.app.rootEl, []));
  const verticalStoryContainerRef = useRef();

  useEffect(() => {
    // Comment out the next two lines if you want to hot-reload
    // any part of the page / visualization
    actions.showOnboarding();
    actions.changeOnboardingIdx(0);
    document.querySelector("#root").classList.add("no-scrollbar");
    return function () {
      document.querySelector("#root").classList.remove("no-scrollbar");
    };
  }, [actions]);

  const scrollToBottom = useCallback(() => {
    tutorialSkipped.current = true;
    verticalStoryContainerRef.current.scrollTo(
      0,
      verticalStoryContainerRef.current.scrollHeight
    );
  }, []);

  const skipTutorial = useCallback(() => {
    new Promise((resolve) => {
      // actions.changeOnboardingIdx(narrativeData.length - 1);
      setTimeout(() => resolve(), tutorialSkipped.current ? 3000 : 1000);
    }).then(() => {
      // actions.hideOnboarding();
      setGoToPlatform(true);
    });
  }, []);

  return (
    <div className="py-navbar">
      <div
        className="flex px2 pb2 z2 fixed full-height-minus-navbar full-width no-pointer-events justify-between"
        style={{
          flexDirection: `row-reverse`,
        }}
      >
        {onboardingIdx !== 0 && (
          <div className="flex flex-column fade-in justify-between relative">
            <ProgressBar
              className="self-end mt1"
              current={onboardingIdx}
              total={narrativeData.length}
            />
            <Button
              className="pointer-events absolute right-0 block-font z2 px2 h3 uppercase button-skip"
              onClick={scrollToBottom}
            >
              Skip
            </Button>
          </div>
        )}
      </div>
      <div
        ref={verticalStoryContainerRef}
        className="vertical-story full-height relative z1"
      >
        {!debugPlatform &&
          narrativeData.map((step, stepIdx) => {
            return (
              <InView
                key={`explore-narrative-${stepIdx}`}
                as="section"
                threshold={isMobile ? 0.5 : 0.5}
                initialInView={stepIdx === 0}
                className={
                  "vertical-story__scene flex flex-column justify-end items-center pb2"
                }
                onChange={(inView, entry) => {
                  inView && actions.changeOnboardingIdx(stepIdx);
                }}
              >
                {/*<div className="step flex flex-column relative m-auto col-12 items-center content-between m-auto">*/}
                <div
                  className="h0 block-font"
                  dangerouslySetInnerHTML={{ __html: step.title }}
                />
                <div className="h2 block-font">{step.subtitle}</div>
                <p
                  className="no-pointer-events h1 sm-12 col-9 mb2 center block-font z1 ch-40"
                  dangerouslySetInnerHTML={{ __html: step.text }}
                />
                {/*</div>*/}
                {stepIdx === 0 && onboardingIdx === 0 && (
                  <ScrollIndicator className="fixed bottom-0 col-12" />
                )}
              </InView>
            );
          })}
        <InView
          as="div"
          className="half-height"
          threshold={0.5}
          initialInView={false}
          onChange={(inView) => {
            if (inView) {
              skipTutorial();
            }
          }}
        >
          {goToPlatform && <Redirect to={urls.platform.path} />}
        </InView>
      </div>
    </div>
  );
}
